import { useEffect, useState, useRef, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, } from 'react-router-dom';

import { MapContainer, TileLayer, Marker, Popup, Polyline, Tooltip, useMapEvent, } from "react-leaflet";
import L from 'leaflet';
import "leaflet/dist/leaflet.css";

import { getIconByType, MyIconBiker, MyIconCurrent, MyIconDestination, } from '../../Constants/mapAttribute';
import { getMapLocations } from '../../Store/Actions/user';
import { stateLocation, } from '../../Store/Actions/auth';
import env from '../../Confgs/vars';
import { AppDispatch } from '../../Store/Reducers';
import Spinner from '../Spinner';

interface LeafletNearestDriversProps {
  customer: any;
  drivers: any;
  handleMapActive?: boolean;
  autoTrace?: boolean;
  height?: string;
  zoom?: number;
  url?: string;
  isReverseGeocode?: boolean;
  isShowHandleDriverClick?: boolean;
  isPickupPoint?: boolean;
  activePolyline?: boolean;
  locationMaps?: any;
}

const LeafletNearestDrivers = ({
  customer,
  drivers,
  handleMapActive = false,
  autoTrace = true,
  height,
  zoom,
  url = "/orderDriver",
  isReverseGeocode = true,
  isPickupPoint = false,
  isShowHandleDriverClick = true,
  activePolyline = true,
  locationMaps
}: LeafletNearestDriversProps) => {


  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();



  const [positions, setPositions] = useState({
    currentPosition: [0, 0] as [number, number],
    recipientPosition: [0, 0] as [number, number],
    polylinePositions: [0, 0] as [number, number],
    selectedPosition: [0, 0] as [number, number],
  });

  const { currentPosition, recipientPosition, polylinePositions, selectedPosition, } = positions;


  const MapClickHandler = ({ onClick }: { onClick: (event: any) => void }) => {
    useMapEvent('click', onClick);
    return null;
  };


  useEffect(() => {
    if (customer) {
      if (drivers?.length > 0) {
        const polylinePositions = drivers
          ?.filter((driver: { is_destination: boolean; }) => driver?.is_destination === true)
          ?.map((driver: { latitude: any; longitude: any; }) => {
            return [[driver?.latitude, driver?.longitude], [customer?.latitude, customer?.longitude]];
          });

        setPositions(prevPositions => ({
          ...prevPositions,
          polylinePositions: polylinePositions,
        }));
      }

      setPositions((prevPositions): any => ({
        ...prevPositions,
        recipientPosition: [customer?.latitude, customer?.longitude],
      }));
    }
  }, [customer, drivers]);

  const reverseGeocode = useCallback(async (lat: any, lng: any) => {
    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
      );
      const data = await response.json();
      return data?.display_name || "Lokasi tidak ditemukan";
    } catch (error) {
      console.error("Error dengan reverse geocoding LeafletNearestDrivers:", error);
      return "Lokasi tidak ditemukan";
    }
  }, []);

  useEffect(() => {
    // Ambil lokasi saat halaman pertama kali dimuat
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;

        setPositions((prevPositions): any => ({
          ...prevPositions,
          currentPosition: [latitude, longitude],
        }));
        // simpan koordinat stateLocation ke global state sebagai pemicu update profile lalu realtime profile
        dispatch(stateLocation([latitude, longitude]));
      },
      (err) => console.log(err),
      { enableHighAccuracy: true }
    );

    if (autoTrace) {
      // Jika autoTrace aktif, jalankan watchPosition
      const watchId = navigator.geolocation.watchPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          let address: any;
          if (isReverseGeocode) {
            address = await reverseGeocode(latitude, longitude);
          }
          setPositions((prevPositions): any => ({
            ...prevPositions,
            currentPosition: [latitude, longitude],
            currentAddress: address ? address : ""
          }));
          dispatch(stateLocation([latitude, longitude]));
        },
        (err) => console.log(err),
        { enableHighAccuracy: true }
      );

      return () => navigator.geolocation.clearWatch(watchId);
    }
  }, [dispatch, autoTrace, isReverseGeocode, reverseGeocode]);

  // serviceWorker
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      // Registrasi Service Worker
      navigator.serviceWorker.register('/service-worker.js').then((registration) => {
      }).catch((error) => {
        console.error('Service Worker gagal registrasi :', error);
      });

      navigator.serviceWorker.addEventListener('message', (event) => {
        const { latitude, longitude } = event.data;
        setPositions((prevPositions): any => ({
          ...prevPositions,
          currentPosition: [latitude, longitude],
        }));
        dispatch(stateLocation([latitude, longitude]));
      });
    }
  }, [dispatch]);

  const handleMapClick = (event: any) => {
    setPositions((prevPositions): any => ({
      ...prevPositions,
      selectedPosition: [event?.latlng?.lat, event?.latlng?.lng]
    }));
    dispatch(stateLocation([event?.latlng?.lat, event?.latlng?.lng]));
  };

  const handleDriverClick = (driver: any) => {
    if (window.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: `DRIVER_DATA`,
          payload: driver,
        })
      );
    }
    // dispatch(stateOrderDriver(driver));
    // dispatch({ type: "DEL_STATUS_ORDERED_RIDE" })
    navigate(url)

  };

  type MapLocation = {
    id: string;
    name: string;
    latitude: number;
    longitude: number;
  };

  const mapRef = useRef<L.Map | null>(null);
  const [zoomMap, setZoomMap] = useState<number>(13);
  const [localMapData, setLocalMapData] = useState<MapLocation[]>([]);
  const zoomCache = useRef<{ [key: number]: any[] }>({});
  const [mapReady, setMapReady] = useState(false);

  const onMapReady = (mapInstance: L.Map) => {
    mapRef.current = mapInstance;
    setMapReady(true);
  };


  useEffect(() => {
    if (!mapReady || !mapRef.current) return;

    const mapInstance = mapRef.current;

    const handleZoom = async () => {
      const zoomLevel = mapInstance.getZoom();
      setZoomMap(zoomLevel);

      if (zoomLevel >= 18) {
        if (zoomCache.current[18]) {
          setLocalMapData([
            ...(zoomCache.current[17] || []),
            ...zoomCache.current[18],
          ]);
        } else {
          const res = await dispatch(getMapLocations({ page: 2, limit: env.mapLimit }));
          const data = (res as any) || [];
          zoomCache.current[18] = data;
          setLocalMapData([
            ...(zoomCache.current[17] || []),
            ...data,
          ]);
        }
      } else if (zoomLevel === 17) {
        if (zoomCache.current[17]) {
          setLocalMapData(zoomCache.current[17]);
        } else {
          const res = await dispatch(getMapLocations({ page: 1, limit: env.mapLimit }));
          const data = (res as any) || [];
          zoomCache.current[17] = data;
          setLocalMapData(data);
        }
      } else {
        setLocalMapData([]);
      }
    };

    mapInstance.on('zoomend', handleZoom);

    return () => {
      mapInstance.off('zoomend', handleZoom);
    };
  }, [dispatch, mapReady]);


  const [mapTile, setMapTile] = useState("osm");
  const [maxZoomState,] = useState(21);

  const handleChangeDistance = (event: any) => {
    setMapTile(event.target.value);
  };

  const [isMapReady, setIsMapReady] = useState(false);

  useEffect(() => {
    if ((Array.isArray(recipientPosition) && recipientPosition.length === 2 && Array.isArray(currentPosition) && currentPosition.length === 2)) {
      setIsMapReady(true);
    }
  }, [recipientPosition, currentPosition]);


  if (!isMapReady) {
    return <div><Spinner /></div>;
  }

  return (
    <>
      <div className="absolute top-1 right-1 z-[1000] bg-white rounded-xl shadow-md p-1">
        <select
          value={mapTile}
          onChange={handleChangeDistance}
          className="text-sm px-1 py-1 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="osm">Default</option>
          <option value="satelite">Satelit</option>
        </select>
      </div>

      <MapContainer
        ref={(mapInstance: L.Map) => {
          if (mapInstance && !mapRef.current) {
            mapRef.current = mapInstance;
            onMapReady(mapInstance);
          }
        }}
        center={recipientPosition ? recipientPosition : currentPosition}
        zoom={zoom ? zoom : zoomMap}
        maxZoom={maxZoomState}
        zoomControl={false}
        style={{
          height: height ? height : "78vh",
          width: "auto",
        }}
        attributionControl={false}
      >
        {handleMapActive && <MapClickHandler onClick={handleMapClick} />}


        {mapTile === "osm" ? (
          <>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              maxZoom={21}
            />
          </>
        ) : (
          <TileLayer
            url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            // attribution='Tiles &copy; Esri'
            maxZoom={18}
          />
        )}

        {/* Marker lokasi */}
        {localMapData?.length > 0 && localMapData?.map((loc: any, index: any) => (
          <Marker
            key={index}
            position={[loc?.latitude, loc?.longitude]}
            icon={getIconByType(loc?.type)}
          >
            <Tooltip
              direction="bottom"
              offset={[0, 20]}
              opacity={1}
              permanent
              className="custom-tooltip"
            >
              {loc?.name}
            </Tooltip>
          </Marker>
        ))}

        {customer ? (
          <>
            {/* Marker driver */}
            {drivers?.map((driver: any, index: any) => {
              return (
                <Marker
                  key={index}
                  position={[driver?.latitude, driver?.longitude]}
                  icon={driver?.is_destination ? MyIconDestination : MyIconBiker}
                  ref={(markerRef) => {
                    if (markerRef && driver?.is_destination) {
                      setTimeout(() => {
                        markerRef.openPopup();
                      }, 0);
                    }
                  }}
                >
                  {isShowHandleDriverClick && (
                    <Popup>
                      <button
                        onClick={() => handleDriverClick(driver)}
                        className="text-blue-600 border border-blue-600 hover:bg-blue-50 px-3 py-1 text-sm rounded-md transition-colors duration-200"
                      >
                        Pilih Driver
                      </button>
                    </Popup>
                  )}

                  {driver?.is_destination && (
                    <Tooltip
                      direction="bottom"
                      offset={[0, 20]}
                      opacity={1}
                      permanent
                      className="custom-tooltip"
                    >
                      Titik Tujuan
                    </Tooltip>
                  )}
                </Marker>
              );
            })}

            {/* Marker anda */}
            <Marker
              position={recipientPosition ?? [0, 0]}
              icon={
                // customer?.file
                //   ? L.icon({
                //     iconUrl: `${env.bucketItem}/users/${customer.file}`,
                //     iconSize: [25, 25],
                //     iconAnchor: [14, 25],
                //     popupAnchor: [0, -25],
                //   })
                //   :
                MyIconCurrent
              }
            >
              {isPickupPoint ? (
                <Tooltip
                  direction="bottom"
                  offset={[0, 20]}
                  opacity={1}
                  permanent
                  className="custom-tooltip"
                >
                  Titik Jemput
                </Tooltip>
              ) : (
                <Popup>Ini lokasi mu</Popup>
              )}
            </Marker>


            {/* Polyline antara driver dan anda */}
            {activePolyline && polylinePositions.map((positions: any, index) => (
              <Polyline key={index} positions={positions} />
            ))}
          </>
        ) : (
          <>
            {currentPosition && (
              selectedPosition ? (
                ""
              ) :
                (
                  <Marker position={currentPosition} icon={MyIconCurrent}>
                    <Popup>Kamu disini</Popup>
                  </Marker>
                )
            )}

            {selectedPosition && (
              <Marker position={selectedPosition} icon={MyIconCurrent}>
                <Popup>Posisi ditentukan disini</Popup>
              </Marker>
            )}
          </>
        )}
      </MapContainer>
    </>
  );
};

export default LeafletNearestDrivers;
